import { render, staticRenderFns } from "./MySNs.vue?vue&type=template&id=36a1f2f8"
import script from "./MySNs.vue?vue&type=script&lang=js"
export * from "./MySNs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports